import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { SearchIcon } from "components/common/Icons/SearchIcon";

interface MemesSearchBoxProps {
    search: string;
    handleSearch: (value: string) => void;
}

export const MemesSearchBox = ({ search, handleSearch }: MemesSearchBoxProps) => {
    return (
        <div className="pl-4 rounded-xl bg-irGray-200 dark:bg-darkSurface-200 border border-irGray-600 dark:border-darkSurface-400 flex items-center text-black dark:text-white">
            <div className="cursor-pointer">
                <SearchIcon />
            </div>
            <input
                className="w-full pl-4 py-3 bg-transparent outline-none"
                placeholder={capitalize(translateFunc("search"))}
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
            />
        </div>
    );
};
